<div #mainDiv_ll_model_classes_lender_edit>


  <div style="position:absolute; " [style.left.px]="bundle.class_gridX - 10" [style.top.px]="0">

    <div class="txtNorm12" [style.position]="'absolute'"
         [style.top.px]="bundle.class_gridY - 20"
         [style.width.px]="bundle.class_gridW"
         [style.left.px]="bundle.class_gridX">
      {{bundle.userMessage}}
    </div>


  </div>

  <!-- ==================== GRID ==================== -->
  <div *ngIf="bundle.showGrids"
       [style.top.px]="bundle.class_gridY"
       [style.left.px]="bundle.class_gridX"
       style="position: absolute;">
    <jqxGrid #datagrid_lender_classes
             [width]="bundle.class_gridW"
             [height]="bundle.class_gridH"
             [rowsheight]='30'
             [sortable]="true"
             [filterable]="true"
             [editable]="true"
             [selectionmode]="'singlerow'"
             [columnsresize]="true"
             (onRowclick)="selectLenderClass($event)">
    </jqxGrid>
  </div>

  <div *ngIf="bundle.activeClassId !== 0"
       [style.top.px]="bundle.class_gridY + bundle.class_gridH + 10"
       [style.left.px]="bundle.class_gridX"
       style="position: absolute;">

    <div class="wordBtn_11" (click)="selectAll()">Select All</div>

  </div>

  <div class="txtNorm12"
       [style.top.px]="bundle.class_gridY + bundle.class_gridH + 10"
       [style.left.px]="bundle.class_gridX + 100"
       style="position: absolute;">

    Select payers below for addition to this class:  {{bundle.activeClassName}}

  </div>

  <div *ngIf="bundle.showGrids"
       [style.top.px]="bundle.payer_gridY"
       [style.left.px]="bundle.payer_gridX"
       style="position: absolute;">
    <jqxGrid #datagrid_payers
             [width]="bundle.payer_gridW"
             [height]="bundle.payer_gridH"
             [rowsheight]='30'
             [sortable]="true"
             [filterable]="true"
             [editable]="true"
             [columnsresize]="true"
             (onCellvaluechanged)="selectPayer($event)"
             (onRowclick)="selectPayer($event)">
    </jqxGrid>
  </div>


  <!-- ==================== SAVE BUTTONS ==================== -->
  <!--<div style="font-size: 12px; font-family: Verdana; margin-top: 30px;">
    <div #beginEdit></div>
    <div #endEdit style="margin-top: 10px;"></div>
  </div>-->
  <!--<div *ngIf="!bundle.saved"
       class="wordBtn_12"
       (click)="save()"
       [style.top.px]="bundle.gridY + bundle.gridH + 10"
       [style.left.px]="bundle.gridX + bundle.gridW - 275"
       [style.width.px]="100"
       style="position: absolute; text-align: center;">
    Click to Save
  </div>-->
  <!--<span *ngIf="!bundle.saved"
        class="txtRed_14"
        [style.top.px]="bundle.gridY - 22"
        [style.left.px]="bundle.gridX"
        style="position: absolute;">
    Enter to Save!
  </span>-->
  <!--<span *ngIf="!bundle.saved"
        class="txtRed_14"
        [style.top.px]="bundle.gridY + bundle.gridH + 10"
        [style.left.px]="bundle.gridX + bundle.gridW - 150"
        style="position: absolute;">
    Key Enter to Save!
  </span>-->
  <!--<div id=gridTarget
       [style.top.px]="bundle.gridY"
       [style.left.px]="bundle.gridX + (bundle.gridW / 2)"
       style="position: absolute;">
    <jqxPopover #popover_dialog
                [selector]="'#gridTarget'"
                [offset]='{ left: 0, top: 300 }'
                [arrowOffsetValue]="-0"
                [showArrow]="false"
                [width]="500"
                [height]="200"
                [position]="'top'"
                [title]="'Apply To'">

      <div style="padding: 10px;">{{bundle.targetElementLabel}} to {{bundle.targetElementValue}}</div>-->
  <!-- Your dialog content, e.g., choices for 'future'/'all' -->
  <!--<div style="padding: 10px;">
        <div *ngIf="bundle.activeCODE === 'model'" style="padding-bottom: 10px;">Do you want this change applied only to future classes added or all current classes and their payers?</div>
        <div *ngIf="bundle.activeCODE === 'classes'" style="padding-bottom: 10px;">Do you want this change applied only to future payers added to this class or all current and future payers in this class?</div>

        <button class="wordBtn14" (click)="applyChoiceAndSave('future')">Future Only   </button>
        <button class="wordBtn14" (click)="applyChoiceAndSave('all')">All Current and Future   </button>
        <button class="wordBtn14" (click)="closeDialog()">Cancel</button>
      </div>
    </jqxPopover>
  </div>-->
  <!--<div id=userEntryMsg
       [style.top.px]="bundle.gridY"
       [style.left.px]="bundle.gridX + (bundle.gridW / 2)"
       style="position: absolute;">
    <jqxPopover #popover_userEntryMsg
                [selector]="'#userEntryMsg'"
                [offset]='{ left: 0, top: 300 }'
                [arrowOffsetValue]="-0"
                [showArrow]="false"
                [width]="500"
                [height]="200"
                [position]="'top'"
                [title]="'Data Setting Notice'">-->
  <!-- Your dialog content, e.g., choices for 'future'/'all' -->
  <!--<div style="padding: 10px;">-->
  <!--<div *ngIf="bundle.activeCODE === 'model'" style="padding-bottom: 10px;">{{bundle.userEntryMessage}}</div>-->
  <!--<div *ngIf="bundle.activeCODE === 'classes'" style="padding-bottom: 10px;">{{bundle.userEntryMessage}}</div>

        <button class="wordBtn14" (click)="applyChoiceAndSave('future')">Future Only</button>
        <button class="wordBtn14" (click)="applyChoiceAndSave('all')">All Current and Future</button>
        <button class="wordBtn14" (click)="closeDialog()">Cancel</button>
      </div>
    </jqxPopover>
  </div>-->

  <div [style.top.px]="bundle.payer_gridY + bundle.payer_gridH + 10"
       [style.left.px]="bundle.payer_gridX"
       style="position: absolute;">

    <div class="wordBtn_11" (click)="exportOnClick()">Download Above List</div>

  </div>

  <div *ngIf="bundle.activeClassId !== 0"
       [style.top.px]="bundle.payer_gridY + bundle.payer_gridH + 10"
       [style.left.px]="bundle.payer_gridX + 150 "
       style="position: absolute;">

    <div class="wordBtn_11" (click)="save()">Save Selected Payers to Selected Class</div>

  </div>

</div>
